import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';
import { createSelector } from 'reselect';
import { useMatchedParams } from '../../../../slices/auth/settings/helper';
import { push } from 'redux-first-history';
import { toggleFontModal } from '../../../../slices/modals/reducer';

function DynamicVideoWarning() {
  const params = useParams();
  const dispatch = useDispatch();
  const selectState = createSelector(state => state, state => ({
    dynamicVideoError: state.Campaign.dynamicVideoError,
    dynamicVideoErrorMsg: state.Campaign.dynamicVideoErrorMsg,
  }));
  const { dynamicVideoError, dynamicVideoErrorMsg } = useSelector(selectState);
  
  return (
    <React.Fragment>
      {dynamicVideoError ?
        <Alert className='mb-3 d-flex align-items-center font-warning' color="danger">
          <p className='w-100 m-0'>
            <i class="ri-error-warning-line me-2 align-middle fs-17"></i>
            {dynamicVideoErrorMsg}
          </p>
        </Alert>
        : null}
    </React.Fragment>
  )
}

export default DynamicVideoWarning
